import { DetailField } from "@Light/components/page/detail/DetailField";
import React from "react";
import {
  AmericanExpressCard,
  AmericanExpressLogo,
} from "./AmericanExpressCard";
import { DiscoverCard, DiscoverLogo } from "./DiscoverCard";
import { GenericCard } from "./GenericCard";
import { MasterCardCard, MasterCardLogo } from "./MasterCardCard";
import { VisaCard, VisaLogo } from "./VisaCard";

export type PaymentMethodCardProps = {
  brand: string;
  lastFour: string;
  expMonth: number;
  expYear: number;
};

export const CARD_BRANDS: Record<string, string> = {
  visa: "Visa",
  mastercard: "MasterCard",
  amex: "American Express",
  discover: "Discover",
  diners: "Diners Club",
  eftpos_au: "Eftpos Australia",
  jcb: "JCB",
  unionpay: "UnionPay",
};

export const getCardBrandDisplay = (brand: string | null | undefined): string =>
  CARD_BRANDS[brand ?? ""] ?? "Unknown";

const CARD_ICONS: Record<string, React.ComponentType> = {
  visa: VisaCard,
  mastercard: MasterCardCard,
  amex: AmericanExpressCard,
  discover: DiscoverCard,
};

export const CARD_BRAND_LOGOS: Record<
  string,
  React.FC<React.ComponentPropsWithoutRef<"svg">>
> = {
  visa: VisaLogo,
  mastercard: MasterCardLogo,
  amex: AmericanExpressLogo,
  discover: DiscoverLogo,
};

export const PaymentMethodCard = ({
  brand,
  lastFour,
  expMonth,
  expYear,
}: PaymentMethodCardProps) => {
  const brandDisplay = getCardBrandDisplay(brand);
  const CardIcon = CARD_ICONS[brand] ?? GenericCard;
  return (
    <div className="rounded-lg border-2 p-4 flex flex-row gap-4 items-start">
      <CardIcon />
      <div className="flex flex-col">
        <DetailField label={`${brandDisplay} ending in ${lastFour}`}>
          Expiry {String(expMonth).padStart(2, "0")}/{expYear}
        </DetailField>
      </div>
    </div>
  );
};
